/**
 * 手机号正则
 *
 * 匹配以特定手机号段开头，后跟8个数字的字符串。这个正则表达式用于验证输入是否符合中国大陆手机号码的一般格式
 */
export const mobileRegExp = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[25678]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);

/**
 * 虚拟号正则
 *
 * 匹配以一个左方括号、后接四个数字、然后是一个右方括号，并且这个结构出现在字符串的结尾部分。
 *
 * @example 可以匹配尾部形如[1234] 的字符串
 */
export const v1VirtualNoRegExp = new RegExp(/(\[(\d{4})\])$/);

/**
 * 手机虚拟号正则
 *
 * 整个正则表达式用于匹配以特定手机号段开头的11位手机号，后面跟着一个短横线，然后是4位数字。
 * @example 匹配的字符串可以是类似于 "13812345678-2022" 的形式。
 */
export const v1VirtualMobileRegExp = new RegExp(
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}-(\d{4})$/,
);

/**
 * 700格式手机虚拟号正则
 *
 * @example 匹配的字符串可以是类似于 "700101234567890" 的形式。
 */

export const v2VirtualMobileRegExp = new RegExp(/^700\d{12}$/);

/**
 * 匹配中国电话号码，包括固定电话和400电话两种格式
 */
export const telephoneRegExp = new RegExp(/(0\d{2,3}-[1-9]\d{6,7}$)|(^400\d{7}$)/);

/**
 * 分隔中英文逗号，顿号，空格，回车
 */
export const splitRegExp = new RegExp(/[,，、\n ]/g);

export function escapeRegExp(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // 转义特殊字符
}

export function matchVirtualIdentifyNo(text: string) {
    if (!text) return null;

    // 1.[5631]
    // 2.转5631
    // 3.-5631
    // 4.（5631）
    const pattern = /(?:\[(\d{4})\])$|(?:转(\d{4}))$|(?:-(\d{4}))$|(?:\((\d{4})\))$/;
    const matchResult = text.match(pattern);
    if (matchResult) {
        return matchResult[1] || matchResult[2] || matchResult[3] || matchResult[4];
    }
    return null;
}
